import React from "react";
import classes from "./Info.module.css";

const Info = (props) => {
  return (
    <div className={classes.info}>
      <h2
        style={{
          marginBottom: "5px",
          color: "#d9d9d9",
          backgroundColor: "#303030",
        }}
      >
        Skills Overview
      </h2>
      <p className={classes.p}>
        I focus on frontend development with React. I also have skills in
        backend development with Spring Framework and AWS Chalice. I love
        creating efficient and user-friendly solutions and enjoy taking on new
        challenges and learning from them.
      </p>
    </div>
  );
};

export default Info;
